import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { fetchThreshold } from "slices/settings/actions/thresholds";
import ThresholdContent from "layout/settings/readabilityThresholds/ThresholdContent";
import { showInlineAlert } from "slices/app/appSlice";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { setActiveTab } from "slices/settings/slices/activeTabSlice";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

const tooltipText =
  "Use the readability thresholds setting to define the standards for what constitutes 'good' and 'bad' readability levels in your documents.";

const ReadabilityThresholds = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-undef
  const { roles } = UserInfo;
  const hasPermissions = roles.split(",").includes("readability_settings");

  useEffect(() => {
    dispatch(setActiveTab(1));
    dispatch(fetchThreshold());
    if (!hasPermissions) {
      dispatch(
        showInlineAlert({
          variant: alertVariants.warning,
          text: "You do not have permission to edit Readability Thresholds",
        })
      );
    }
  }, [dispatch]);

  return (
    <div className="readability_thresholds">
      <div className="readability_thresholds__header">
        <h1>Readability Thresholds</h1>

        <TooltipTrigger content={tooltipText}>
          <div
            className="readability_thresholds__header__info_icon"
            aria-label="information tooltip icon"
          >
            i
          </div>
        </TooltipTrigger>
      </div>
      <ThresholdContent />
    </div>
  );
};

export default ReadabilityThresholds;
